import { Component } from '@angular/core';
import { IBreadcrumb } from '@core-lib/models/breadcrumb.model';
import { BreadcrumbService } from '@core-lib/services/breadcrumb.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app-breadcrumb.component.html',
    standalone: false
})
export class AppBreadcrumbComponent {
	public breadcrumbs: Observable<IBreadcrumb[]> = this.breadcrumbService.breadcrumbs$;

	constructor(private breadcrumbService: BreadcrumbService) {}
}
